"use client"

import { useQuery } from '@tanstack/react-query'
import { useParams } from 'react-router-dom'
import { getTestResultByIdService } from '@/api/services/testService'
import TestResults from "./TestResults"
import { Skeleton } from '@/components/skeleton'
import PageWrap from '@/components/layout/containers/PageWrap'
import useUserStore from '@/store/userStore'
import { useShallow } from 'zustand/shallow'

export default function TestResultsPage() {
  const { id } = useParams<{ id: string }>()
  const { user } = useUserStore(
    useShallow((state) => ({
      user: state.user
    }))
  )

  const { data, isLoading, error } = useQuery({
    queryKey: ['test-result', id],
    queryFn: async () => {
      if (!id) return null
      const response = await getTestResultByIdService(id)
      if (!response.success) {
        console.error('Błąd API:', response.data)
        return null
      }
      return response.data
    }
  })

  if (isLoading) {
    return (
      <PageWrap>
        <div className="p-6">
          <Skeleton className="h-8 w-1/3 mb-4" />
          <Skeleton className="h-4 w-1/2 mb-2" />
          <Skeleton className="h-4 w-3/4" />
        </div>
      </PageWrap>
    )
  }

  if (error || !data) {
    return (
      <PageWrap>
        <div className="p-6">
          <div className="text-red-500">Wystąpił błąd podczas ładowania wyników testu</div>
        </div>
      </PageWrap>
    )
  }

  return (
    <main>
      <TestResults userName={`${user?.firstName} ${user?.lastName}`} result={data}/>
    </main>
  )
}
